import React, { useState } from 'react';

import { ShortCodeEnums } from '@nhl/nhl-breakaway-ui';

import { PlayerPositionLong } from '~/core/enums';

import { IceSurfacePlayer } from '../../../../types';
import PlayerPopover from '../PlayerPopover/PlayerPopover';

import { PlayerDiv, PlayerMarkerContainer } from './styles';

type PlayerProps = {
    player: IceSurfacePlayer;
    teamAbbrev: ShortCodeEnums.TeamTriCode;
    sweaterNumber?: number;
    isHome: boolean;
    position?: PlayerPositionLong;
};

const PlayerMarker: React.FC<PlayerProps> = ({ player, teamAbbrev, sweaterNumber, isHome, position }) => {
    const [showPopover, setShowPopover] = useState(false);

    return (
        <PlayerMarkerContainer onMouseEnter={() => setShowPopover(true)} onMouseLeave={() => setShowPopover(false)}>
            <PlayerDiv $teamAbbrev={teamAbbrev} $isHome={isHome}>
                {sweaterNumber}
            </PlayerDiv>

            {showPopover && (
                <PlayerPopover player={player} teamAbbrev={teamAbbrev} isPenalty={position === undefined} />
            )}
        </PlayerMarkerContainer>
    );
};

export default PlayerMarker;
